import { MeasurableGroupType } from '@upright/common/model/input/measurable-group/types';
import { ModelEntityType, NamedModelEntityReference } from '../../../../../../../common/model/input/types';
import { ExampleEntityIds } from '../../../../../../../common/model/output/scores/hard-coded-entity-ids';
import {
  AdditionalSearchType,
  HeaderSearchSelection,
  ModelEntitySearchResponseItem,
} from '../../../../../../../common/model/search/types';

export function toSearchResponseItem(ref: NamedModelEntityReference): ModelEntitySearchResponseItem {
  return {
    ...ref,
    teaser: false,
  };
}

function modelEntityReferenceToSearchResponseItemArray(
  data?: Array<NamedModelEntityReference & { description?: string }>,
) {
  if (!data || data.length === 0) {
    return undefined;
  }
  const entitiesWithNames = data.filter(g => g.name);
  const sortedEntities = entitiesWithNames.sort((a, b) => a.name.localeCompare(b.name));
  const top10 = sortedEntities.slice(0, 10);

  return top10.map(toSearchResponseItem);
}

export const vaisala = {
  id: ExampleEntityIds.VAISALA,
  type: ModelEntityType.COMPANY,
  name: `Vaisala`,
  description: `Vaisala is a Finnish company that develops, manufactures and markets products and services for environmental and industrial measurement.`,
};
export const pfizer = {
  id: ExampleEntityIds.PFIZER,
  type: ModelEntityType.COMPANY,
  name: `Pfizer`,
  country: 'USA',
  description: `Pfizer is one of the world's largest pharmaceutical companies. The company develops and produces medicines and vaccines for a wide range of medical disciplines`,
};
export const apple = {
  id: ExampleEntityIds.APPLE,
  type: ModelEntityType.COMPANY,
  name: `Apple`,
  country: 'USA',
  description: `Apple Inc. is an American multinational technology company headquartered in Cupertino, California, that designs, develops, and sells consumer electronics, computer software, and online services.`,
};
export const cargotec = {
  id: ExampleEntityIds.CARGOTEC,
  type: ModelEntityType.COMPANY,
  name: `Cargotec`,
  description: `Cargotec Oyj (trading internationally as Cargotec Corporation) is a Finnish company that makes cargo-handling machinery for ships, ports, terminals and local distribution.`,
};
export const securitas = {
  id: ExampleEntityIds.SECURITAS,
  type: ModelEntityType.COMPANY,
  name: `Securitas`,
  description: `Securitas AB is a security services (security guarding and mobile patrolling), monitoring, consulting and investigation group, based in Stockholm, Sweden.`,
};
export const uponor = {
  id: ExampleEntityIds.UPONOR,
  type: ModelEntityType.COMPANY,
  name: `Uponor`,
  description: `Uponor Corporation is a company that sells products for drinking water delivery, radiant heating and cooling. The corporation has approximately 4,000 employees.`,
};
export const taaleri = {
  id: ExampleEntityIds.TAALERI,
  type: ModelEntityType.COMPANY,
  name: `Taaleri`,
  description: `Taaleri is a Nordic investment and asset manager with an emphasis on renewable energy and other alternative investments. Our private equity funds create, for example, wind and solar power, biofuels and real estate.`,
};
// const ge = {
//   id: ExampleEntityIds.GE,
//   type: ModelEntityType.COMPANY,
//   name: 'General Electric',
//   description: `General Electric Company (GE) is an American multinational conglomerate incorporated in New York City and headquartered in Boston. As of 2018, the company operates through the following segments: aviation, healthcare`,
// };
export const tesla = {
  id: ExampleEntityIds.TESLA,
  type: ModelEntityType.COMPANY,
  name: 'Tesla',
  country: 'USA',
  description: `Tesla, Inc. is an American multinational corporation that specializes in electric vehicles, energy storage and solar panel manufacturing based in Palo Alto, California. Founded in 2003, the company specializes in electric cars, lithium-ion battery energy storage, and residential photovoltaic panels (through the subsidiary company SolarCity). The additional products Tesla sells include the Tesla Powerwall and Powerpack batteries, solar panels and solar roof tiles.`,
};
export const siemens = {
  id: ExampleEntityIds.SIEMENS,
  type: ModelEntityType.COMPANY,
  name: 'Siemens',
  country: 'DEU',
  description: `Siemens AG is a German conglomerate company headquartered in Berlin and Munich and the largest industrial manufacturing company in Europe with branch offices abroad.`,
};
export const fiskars = {
  id: ExampleEntityIds.FISKARS,
  type: ModelEntityType.COMPANY,
  name: 'Fiskars',
  description: `Fiskars Oyj Abp is a consumer goods company founded in 1649 in Fiskars Village (Finnish: Fiskarsin Ruukki), a locality now in the town of Raseborg, Finland, about 100 kilometres (62 mi) west of Helsinki.`,
};
export const lamor = {
  id: ExampleEntityIds.LAMOR,
  type: ModelEntityType.COMPANY,
  name: 'Lamor',
  description: `Lamor is a Finnish company focusing on environmental services and products. In 2020, Lamor's key business areas included oil spill response, waste management and water treatment. Lamor's products are used in over a hundred countries, and there are subsidiaries in Bolivia, China, Great Britain, Guyana, India, Kazakhstan, Colombia, Oman, Peru, Russia, Saudi Arabia, Turkey and Ukraine and the United States`,
};
export const shell = {
  id: ExampleEntityIds.SHELL,
  type: ModelEntityType.COMPANY,
  name: 'Shell',
  description:
    'Royal Dutch Shell plc (LSE: RDSA, RDSB), commonly known as Shell, is a British-Dutch oil and gas company headquartered in the Netherlands and incorporated in the United Kingdom.',
};

// OA: McD temporarily removed on Oct 5 2021, to be brought back when the results make sense
// const mcDonalds = {
//   id: ExampleEntityIds.MAC_DONALDS,
//   type: ModelEntityType.COMPANY,
//   name: `McDonald's`,
//   // tslint:disable-next-line: max-line-length
//   description: `McDonald's is an American fast food company, founded in 1940 as a restaurant operated by Richard and Maurice McDonald, in San Bernardino, California, United States.`,
// };

// EXAMPLE PRODUCTS

const drinks = {
  id: ExampleEntityIds.SUGAR_SWEETENED_SOFT_DRINKS,
  type: ModelEntityType.PRODUCT,
  name: 'Sugar-sweetened soft drinks',
  description:
    'Sugar-sweetened beverages are drinks with added sugar including: non-diet soft drinks, flavored juice drinks, sports drinks, sweetened tea, coffee drinks, energy drinks, and electrolyte replacement drinks.',
};

const beer = {
  id: ExampleEntityIds.BEERS,
  type: ModelEntityType.PRODUCT,
  name: 'Beer',
  description: 'Beer is an alcoholic bewerage usually made from malted cereal grain',
};

const paylo = {
  id: ExampleEntityIds.PAYDAY_LOANS,
  type: ModelEntityType.PRODUCT,
  name: `Payday loans`,
  description: 'small, short-term unsecured loans that often have very interest rates.',
};

const antib = {
  id: ExampleEntityIds.ANTIBIOTICS,
  type: ModelEntityType.PRODUCT,
  name: 'Antibiotics',
  description: `drugs used in the treatment and prevention of bacterial infections.`,
};

const foodSafety = {
  id: ExampleEntityIds.FOOD_SAFETY,
  type: ModelEntityType.PHENOMENON,
  name: 'Food safety',
  description: `refers to routines in the preparation, handling and storage of food meant to prevent foodborne illness and injury.`,
};

const hygge = {
  id: ExampleEntityIds.HYGGE,
  type: ModelEntityType.PHENOMENON,
  name: 'Hygge',
  description: `a mood of coziness and comfortable conviviality with feelings of wellness and contentment.`,
};

const tourism = {
  id: ExampleEntityIds.TOURISM,
  type: ModelEntityType.PHENOMENON,
  name: 'Tourism',
  description: `the activities of people traveling to and staying in places outside their usual environment for leisure, business or other purposes for not more than one consecutive year.`,
};

const readingNews = {
  id: ExampleEntityIds.READING_NEWS,
  type: ModelEntityType.PHENOMENON,
  name: 'Reading news',
  description: `the action of reading out the news on radio or television.`,
};

const vaccinating = {
  id: ExampleEntityIds.VACCINATING,
  type: ModelEntityType.PHENOMENON,
  name: 'Vaccinating',
  description: `treating with a vaccine to produce immunity against a disease.`,
};

// EXAMPLE GROUPS

// const fortune = {
//   id: ExampleEntityIds.FORTUNE_500,
//   type: ModelEntityType.GROUP,
//   name: 'US Fortune 500',
//   description: 'Fortune 500 companies represent two-thirds of the U.S. GDP.',
// };

/*
const fortuneGlobal = {
  id: ExampleEntityIds.FORTUNE_500_GLOBAL,
  type: ModelEntityType.GROUP,
  name: 'Fortune Global 500',
  description:
    'The Fortune Global 500, also known as Global 500, is an annual ranking of the top 500 corporations worldwide as measured by revenue.',
};
*/

// const nasdaqHelsinki = {
//   id: ExampleEntityIds.NASDAQ_HELSINKI,
//   type: ModelEntityType.GROUP,
//   name: 'Nasdaq Helsinki',
//   description:
//     'Companies in this group are constituents of Nasdaq Helsinki, a stock exchange located in Helsinki, Finland.',
// };

const vanguardTotalStockMarketETF = {
  id: ExampleEntityIds.VANGUARD_TOTAL_STOCK_MARKET_ETF,
  type: ModelEntityType.GROUP,
  name: 'Vanguard Total Stock Market ETF',
  description:
    'The Vanguard Total Stock Market ETF is a stock index designed by Vanguard. The fund seeks to track a market-cap-weighted portfolio that provides total market exposure to theb US equity space.',
  groupType: MeasurableGroupType.FUND,
};

const snp500ESG = {
  id: ExampleEntityIds.SNP_500_ESG,
  type: ModelEntityType.GROUP,
  name: 'S&P 500 ESG',
  description:
    'The S&P 500 ESG Index is a broad-based, market-cap-weighted index that is designed to measure the performance of securities meeting sustainability criteria, while maintaining similar overall industry group weights as the S&P 500.',
  groupType: MeasurableGroupType.INDEX, // A lie, the real db entry type is fund
};

const euroStoxx50 = {
  id: ExampleEntityIds.EURO_STOXX_50,
  type: ModelEntityType.GROUP,
  name: 'Euro Stoxx 50',
  description:
    'The EURO STOXX 50 is a stock index of Eurozone stocks designed by STOXX, an index provider owned by Deutsche Börse Group.',
  groupType: MeasurableGroupType.FUND,
};

const blackStoneGrowth = {
  id: ExampleEntityIds.BLACKSTONE_GROWTH_I,
  type: ModelEntityType.GROUP,
  name: 'Blackstone Growth I',
  description: `Blackstone Growth I is a 2020 vintage private equity growth expansion fund managed by Blackstone. The fund is located in New York, New York.`,
  groupType: MeasurableGroupType.FUND,
};

const atomicoV = {
  id: ExampleEntityIds.ATOMICO_V,
  type: ModelEntityType.GROUP,
  name: 'Atomico V',
  description:
    'Atomico V is a 2020 vintage early stage venture capital fund managed by Atomico. The fund is based in London, United Kingdom, and invests in the information technology sector across Europe.',
  groupType: MeasurableGroupType.FUND,
};

const privateEquityInvestingInClothing = {
  id: ExampleEntityIds.PRIVATE_EQUITY_FUNDS_INVESTING_IN_CLOTHING,
  type: ModelEntityType.MIXIN,
  name: 'Private equity funds investing in clothing',
  description: `private equity funds investing in clothing.`,
};

const consultingForConstruction = {
  id: ExampleEntityIds.CORPORATE_GOVERNANCE_COMPLIANCE_CONSULTING_FOR_THE_CONSTRUCTION_INDUSTRY,
  type: ModelEntityType.MIXIN,
  name: 'Corporate governance consulting for the construction industry',
  description: `corporate governance consulting for the construction industry.`,
};

const fundsInvestingInIndustrial = {
  id: ExampleEntityIds.REAL_ESTATE_FUNDS_INVESTING_IN_INDUSTRIAL_BUILDINGS,
  type: ModelEntityType.MIXIN,
  name: 'Real estate funds investing in industrial buildings',
  description: `real estate funds investing in industrial buildings.`,
};

const glassProcessing = {
  id: ExampleEntityIds.GLASS_PROCESSING_MACHINERY_FOR_CAR_WINDOWS,
  type: ModelEntityType.MIXIN,
  name: 'Glass processing machinery for car windows',
  description: `glass processing machinery for car windows.`,
};

const productItems: ModelEntitySearchResponseItem[] = [antib, drinks, beer, paylo];
const mixinItems: ModelEntitySearchResponseItem[] = [
  privateEquityInvestingInClothing,
  consultingForConstruction,
  fundsInvestingInIndustrial,
  glassProcessing,
];
// The listed companies carry the country the search returns for them (alpha-3), which the unified
// shell's search panel shows where a result row does.
const companyItems: ModelEntitySearchResponseItem[] = [siemens, pfizer, apple, tesla];
const phenomenonItems: ModelEntitySearchResponseItem[] = [foodSafety, hygge, tourism, readingNews, vaccinating];
const groupItems: ModelEntitySearchResponseItem[] = [
  euroStoxx50,
  snp500ESG,
  vanguardTotalStockMarketETF,
  blackStoneGrowth,
  atomicoV,
];
export const everythingItems: ModelEntitySearchResponseItem[] = [
  siemens,
  pfizer,
  apple,
  tesla,
  // fortuneGlobal, OH 10.9. Removed until fund screener solved to not show other than Finnhub funds + customer funds
  snp500ESG,
  vanguardTotalStockMarketETF,
  blackStoneGrowth,
];

export function getSearchSuggestions(
  type: HeaderSearchSelection | undefined,
  groups?: Array<NamedModelEntityReference & { description?: string }>,
  portfolios?: Array<NamedModelEntityReference & { description?: string }>,
): ModelEntitySearchResponseItem[] {
  switch (type) {
    case undefined:
    case AdditionalSearchType.ALL:
    case AdditionalSearchType.ALL_INTERNAL:
      return everythingItems.map(toSearchResponseItem);
    case ModelEntityType.COMPANY:
    case 'legalEntity':
      return companyItems.map(toSearchResponseItem);
    case ModelEntityType.PHENOMENON:
      return phenomenonItems.map(toSearchResponseItem);
    case ModelEntityType.PRODUCT:
      return productItems.map(toSearchResponseItem);
    case ModelEntityType.MIXIN:
      return mixinItems.map(toSearchResponseItem);
    case ModelEntityType.GROUP:
      return modelEntityReferenceToSearchResponseItemArray(groups) || groupItems.map(toSearchResponseItem);
    case ModelEntityType.PORTFOLIO:
      return modelEntityReferenceToSearchResponseItemArray(portfolios) ?? [];
  }
}
